import React, { useState } from 'react'
import '../../style/FaiDaTe/FaiDaTe.scss'
import HeaderBack from './_HeaderBack'
import spostamento from '../../assets/img/spostamento.svg'
import axios from 'axios'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

function Spostamento() {
    const navigate = useNavigate()
    const [checkBox, setCheck] = useState(false)
    const [selectValue, setSelectVal] = useState('10')
    const podCode = useSelector((user) => user.user.info.pod_code)
    const customerId = useSelector((user) => user.user.info.customer_id)
    const costo = useSelector((user) => user.faidate.costi)
    const check = () => {
        if(!checkBox){
            alert('Devi accettare termini e condizioni')
        } else {
            const url = `https://my.revoluce.it/area_utente/gestione/api/faidate/spostamentoContatore.php?customer_id=${customerId}&codice_pod=${podCode}&lunghezza_spostamento=${selectValue}`
            axios.get(url)
            navigate('/enrica/richiesta-inoltrata')
        }
    }
    return (
        <div className="faiDaTe_component">
            <HeaderBack text="Fai da te" step={0}/>
            <div className="icon">
                <img src={spostamento} alt="spostamento" />
            </div>
            <div className="body">
                <div className="paragraph">
                    <h1 className="h1">Spostamento contatore</h1>
                    <p>Puoi richiedere lo spostamento del gruppo di misura all’interno della tua proprietà.</p>
                </div>
                <div className="paragraph">
                    <h2 className="h2">Cosa si intende per spostamento del gruppo di misura?</h2>
                    <p>Puoi decidere, se ne hai necessità, di spostare il contatore all’interno della stessa particella catastale o in un’altra particella all’interno della quale non è presente un contatore.</p>
                </div>
                <div className="paragraph">
                    <h2 className="h2">Tempi e Costi</h2>
                    <p>I tempi e i costi di questa richiesta variano in base al tipo di spostamento necessario:</p>
                    <p>
                        <span className="bold">Spostamento entro i 10 metri</span> <br/>
                        <span className="bold">Tempo massimo di lavorazione:</span> 10 giorni lavorativi dall'invio della richiesta. <br/>
                        <span className="bold">Costo:</span> € {costo !== null ? costo : ''} IVA inclusa.
                    </p>
                    <p>
                        <span className="bold">Spostamento oltre i 10 metri</span> <br/>
                        <span className="bold">Tempo massimo di lavorazione:</span> 15 giorni per l'emissione del preventivo. Una volta accettato il preventivo se sono lavori semplici il distributore ha 10 giorni lavorativi per eseguire la prestazione, mentre se sono necessari lavori complessi ha tempo fino a 50 giorni lavorativi. <br/>
                        <span className="bold">Costo:</span> da preventivare ad hoc.
                    </p>
                </div>
                <div className="paragraph boxForm">
                    <h2 className="h2">Voglio spostare il mio contatore</h2>
                    <select onChange={(e) => setSelectVal(e.target.value)}>
                        <option selecct value="10">Entro i 10 metri</option>
                        <option value="oltre">Oltre i 10 metri</option>
                    </select>
                    <div className="checkbox">
                        <input type="checkbox" onChange={() => setCheck(!checkBox)}/>
                        <p>Proseguendo con l’invio della richiesta dichiaro di aver letto ed accettato le tempistiche necessarie per il completamento dell’operazione e il preventivo di costo indicato.</p>
                    </div>
                    <div className="cta">   
                        <button onClick={() => check()}>Inoltra richiesta</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Spostamento
